// src/components/strumenti/ConversionePendenza.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConversionePendenza() {
  const [modo, setModo] = useState("perc_gradi");
  const [valore, setValore] = useState("");

  const v = leggiNumero(valore)||0;
  const risultato = modo==="perc_gradi" ? Math.atan(v/100)*(180/Math.PI) : Math.tan(v*(Math.PI/180))*100;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("perc_gradi");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="perc_gradi"?"#15803d":"#e5e7eb"}`, background: modo==="perc_gradi"?"#f0fdf4":"#fff", color: modo==="perc_gradi"?"#15803d":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>% → gradi</button>
        <button onClick={()=>{setModo("gradi_perc");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="gradi_perc"?"#15803d":"#e5e7eb"}`, background: modo==="gradi_perc"?"#f0fdf4":"#fff", color: modo==="gradi_perc"?"#15803d":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Gradi → %</button>
      </div>

      <div style={{ marginBottom:16 }}>
        <label style={lbl}>{modo==="perc_gradi" ? "Pendenza (%)" : "Angolo (gradi)"}</label>
        <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder={modo==="perc_gradi"?"Es. 20":"Es. 11.3"}/>
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risultato</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#15803d" }}>
          {v!==0 || valore ? risultato.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="perc_gradi" ? "°" : "%"}</span>
        </div>
      </div>

      <button onClick={()=>setValore("")}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
